<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '25rem' }"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-500"
      >
        <i class="pi pi-user text-2xl"></i>
      </div>
      <span class="text-xl font-semibold text-greyscale-900">
        {{
          mode === "create"
            ? ("companyClientList.dialogTitleCreate" | transloco)
            : ("companyClientList.dialogTitleEdit" | transloco)
        }}
      </span>
    </div>
  </ng-template>
  <form class="flex flex-col gap-4" [formGroup]="clientForm">
    <div class="flex-1">
      <label for="clientName" class="mb-1 block text-sm text-primary-500">
        {{ "companyClientList.clientNameLabel" | transloco }}
      </label>
      <input
        id="clientName"
        type="text"
        pInputText
        formControlName="name"
        [fluid]="true"
        [placeholder]="'companyClientList.clientNamePlaceholder' | transloco"
        data-testid="client.name.input"
      />
    </div>

    <div class="flex-1">
      <div class="mb-1 block text-sm text-primary-500">
        {{ "logoUpload.clientLogoLabel" | transloco }}
      </div>
      <app-logo-upload
        [currentLogoUrl]="client?.logoUrl"
        [uploading]="loading"
        shape="round"
        (logoCropped)="onLogoCropped($event)"
      />
    </div>

    <div class="flex-1">
      <label for="clientPublicId" class="mb-1 block text-sm text-primary-500">
        {{ "companyClientList.clientPublicIdLabel" | transloco }}
      </label>
      <input
        id="clientPublicId"
        type="text"
        pInputText
        formControlName="publicId"
        [fluid]="true"
        [placeholder]="
          'companyClientList.clientPublicIdPlaceholder' | transloco
        "
        data-testid="client.publicId.input"
      />
      @if (clientForm.controls.publicId.pending) {
        <div class="mt-1 text-xs text-greyscale-500">
          {{ "companyClientList.publicIdChecking" | transloco }}
        </div>
      } @else if (
        clientForm.controls.publicId.touched &&
        clientForm.controls.publicId.errors?.["publicId"]
      ) {
        <div
          class="mt-1 text-xs text-red-500"
          data-testid="client.publicId.error"
        >
          {{
            (clientForm.controls.publicId.errors?.["publicId"] ===
            "E_PUBLIC_ID_SELF_REFERENCE"
              ? "companyClientList.errorPublicIdSelfReference"
              : "companyClientList.errorPublicIdNotFound"
            ) | transloco
          }}
        </div>
      }
    </div>
  </form>
  <div class="mt-4 flex justify-end gap-2">
    <p-button
      [label]="'companyClientList.cancel' | transloco"
      severity="secondary"
      (click)="closeDialog()"
      data-testid="client.form.cancel"
    />
    <p-button
      [label]="
        mode === 'create'
          ? ('companyClientList.add' | transloco)
          : ('companyClientList.save' | transloco)
      "
      (click)="submit()"
      [loading]="loading"
      [disabled]="clientForm.invalid || clientForm.pending"
      data-testid="client.form.submit"
    />
  </div>
</p-dialog>
